export default __webpack_public_path__ + "static/media/060_corner2.hevc.40863e4e.mp4";